import { BaseTableProps } from './internal';

export const defaultRenderCell = () => null;
export const defaultSizes = {
  tableWidth: 600,
  tableHeight: 400,
  rowHeight: 40,
  columnWidth: 150,
  selectionControlColumnWidth: 40,
  minimumUnfrozenColumnWidth: 100,
  minimumColumnWidth: 64,
  maximumColumnWidth: 1000,
  dropIndicatorLineHeight: 2,
};

/**
 * Default values and functions used by Table and associated utilities.
 */
export const Defaults: {
  sizes: any;
  selectionMode: NonNullable<BaseTableProps['selectionMode']>;
  getRowKey: NonNullable<BaseTableProps['getRowKey']>;
  renderCell: NonNullable<BaseTableProps['renderCell']>;
} = {
  sizes: defaultSizes,
  selectionMode: 'multiple',
  getRowKey: (rowIndex: number) => rowIndex.toString(),
  renderCell: defaultRenderCell,
};
